import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { ShieldOff } from 'lucide-react';
import { ipsBloqueadosAPI } from '../../utils/adminSegurancaAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';
import ModalRodape from './ModalRodape';

const inputClasses = 'w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-[#40A1E6] focus:ring-2 focus:ring-[#40A1E6]/15 outline-none transition-all font-mono';
const labelClasses = 'block text-sm font-medium text-gray-700 mb-1.5';

// ipInicial vem preenchido quando o admin bloqueia direto a partir da lista
// de "IPs livres" (já sabe o endereço, só falta confirmar o motivo).
const BloquearIpModal = ({ ipInicial, onFechar, onBloqueado }) => {
  const [enviando, setEnviando] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { ip: ipInicial || '', motivo: '' }
  });

  const onSubmit = async (dados) => {
    setEnviando(true);
    try {
      await ipsBloqueadosAPI.bloquear(dados.ip.trim(), dados.motivo?.trim());
      sucessoComHorario(`IP ${dados.ip.trim()} bloqueado`);
      onBloqueado();
      onFechar();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao bloquear IP');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label htmlFor="bloquear-ip-endereco" className={labelClasses}>Endereço IP</label>
        <input
          id="bloquear-ip-endereco"
          {...register('ip', {
            required: 'IP é obrigatório',
            pattern: { value: /^(\d{1,3}\.){3}\d{1,3}$|^[0-9a-f:]+$/i, message: 'Formato de IP inválido' }
          })}
          className={inputClasses}
          placeholder="Ex: 203.0.113.42"
          autoFocus={!ipInicial}
          readOnly={!!ipInicial}
        />
        {errors.ip && <p className="text-sm text-red-600 mt-1">{errors.ip.message}</p>}
      </div>

      <div>
        <label htmlFor="bloquear-ip-motivo" className={labelClasses}>Motivo (opcional)</label>
        <input id="bloquear-ip-motivo" {...register('motivo')} className={inputClasses.replace(' font-mono', '')} placeholder="Ex: tentativas de força bruta no login" autoFocus={!!ipInicial} />
      </div>

      <ModalRodape>
        <button type="submit" disabled={enviando} className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg px-4 py-2.5 transition-colors disabled:opacity-50">
          <ShieldOff className="w-4 h-4" /> {enviando ? 'Bloqueando...' : 'Bloquear'}
        </button>
      </ModalRodape>
    </form>
  );
};

export default BloquearIpModal;
